export default {
      id: "icon--membership-usage",
      viewBox: "0 0 31.6 31",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--membership-usage",
      toString: function () {
        return this.url;
      }
    }